import { CommonFilter, ItemSelector, SelectComponentFilter, SelectFilter } from '../types/filter'

export enum DateOperator {
    InTheLast = 'last',
    LessThan = '<',
    LessThanOrEqualTo = '<=',
    GreaterThan = '>',
    GreaterThanOrEqualTo = '>=',
    EqualTo = '=',
    IsNull = 'isNull',
    Between = 'between',
}

export enum Operator {
    GreaterThan = '>',
    GreaterThanOrEqualTo = '>=',
    LessThan = '<',
    LessThanOrEqualTo = '<=',
    EqualTo = '=',
    NotEqualTo = '!=',
    IsNull = 'isNull',
    Between = 'between',
}

export interface NumericFilter extends CommonFilter {
    operators: Operator[]
    type: 'number' | 'nullable-number'
}

export interface DateFilter extends CommonFilter {
    operators: DateOperator[]
    type: 'date'
}

type FilterValueObject = {
    // [Operator.InTheLast]?: string,
    [Operator.GreaterThan]?: string
    [Operator.GreaterThanOrEqualTo]?: string
    [Operator.LessThan]?: string
    [Operator.LessThanOrEqualTo]?: string
    [Operator.EqualTo]?: string
    [Operator.Between]?: string
    period?: 'days' | 'months'
}
export type NumericFilterValue = number | FilterValueObject
export type DateFilterValue = FilterValueObject
export type FilterValue = ItemSelector | NumericFilterValue | DateFilterValue | string
export type FilterI = NumericFilter | SelectFilter | SelectComponentFilter | DateFilter
